import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface EventTypeState {
    data: [] | null | any;
    currentPage: number | null;
    totalRecords: number | null;
    totalPages: number | null;
    allEventType: [] | null | any;
}
const initialState: EventTypeState = {
    data: null,
    totalRecords: null,
    totalPages: null,
    currentPage: null,
    allEventType: null,
};
export const eventTypeSlice = createSlice({
    name: 'EventType',
    initialState,
    reducers: {
        setAllEventType: (state, action) => {
            state.allEventType = action.payload.data;
        },
        setEventType: (state, action) => {
            state.data = action.payload.data.data ? action.payload.data.data : action.payload.data;
            state.totalRecords = action.payload.data.totalRecords;
            state.totalPages = action.payload.data.totalPages;
            state.currentPage = action.payload.data.currentPage;
        },
        reset: (state) => {
            Object.assign(state, initialState);
        },
    },
});
export const { setAllEventType, setEventType, reset } = eventTypeSlice.actions;
export const allEventTypeDetails = (state: RootState) => state.eventType.allEventType;
export const getAllEventTypeDetails = (state: RootState) => state.eventType.data;
export const getEventTypeTotalRecords = (state: RootState) => state.eventType.totalRecords;
export default eventTypeSlice.reducer;
